import React from 'react';
import { Brain, Mail, Github, Twitter } from 'lucide-react';
import { Link } from 'react-router-dom';
import { LogoIcon } from '../common/Logo';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { name: '模型工厂', href: '/models' },

      { name: '问题诊断', href: '/problem-diagnosis' },
      { name: 'AI助手', href: '/ai-assistant' },
    ],
    company: [
      { name: '联系我们', href: '#contact' },
      { name: '隐私政策', href: '#privacy' },
      { name: '服务条款', href: '#terms' },
    ],
    resources: [
      { name: '帮助中心', href: '#help' },
      { name: '用户指南', href: '#guide' },
      { name: '常见问题', href: '#faq' },
      { name: '更新日志', href: '#changelog' },
    ],
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo和描述 */}
          <div className="col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <LogoIcon size="lg" />
              <span className="text-lg font-bold">
                Leap<span className="text-blue-400">Ward</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              基于热点新闻的深度案例分析，AI专家级解读，让思维过程变得清晰可见。
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                <Mail className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                <Github className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* 产品链接 */}
          <div>
            <h3 className="font-semibold mb-4">产品</h3>
            <ul className="space-y-2">
              {footerLinks.product.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 公司链接 */}
          <div>
            <h3 className="font-semibold mb-4">公司</h3>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 资源链接 */}
          <div>
            <h3 className="font-semibold mb-4">资源</h3>
            <ul className="space-y-2">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* 底部版权 */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} LeapWard.app. 保留所有权利.
          </p>
          <div className="flex space-x-6 mt-4 sm:mt-0">
            <a href="#privacy" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
              隐私政策
            </a>
            <a href="#terms" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;